module.exports = __webpack_public_path__ + "img/winking_face_with_tongue.d4ba3463.gif";